import { Component, OnInit } from '@angular/core';
import { AppServiceService } from '../service/app-service.service';

@Component({
  selector: 'app-how-to-search-departments',
  templateUrl: './how-to-search-departments.component.html',
  styleUrls: ['./how-to-search-departments.component.css']
})
export class HowToSearchDepartmentsComponent implements OnInit {

  constructor(private appService: AppServiceService) { }

  ngOnInit(): void {
	this.appService.setTitle('Search Departments');
  }

}
